import React from 'react';
import './StatusCircle.css';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

interface StatusCircleProps {
  textSize: number;
  ccParam : any;
}

//const JSON5 = require("json5")

export const getCircleParam = (wfBanner:string, text:string, PG_CIRCLE:any, PG_TEXT:any) => {

  var result = {
    type:1,
    color:'black',
    bgColor:'white',
    pathColor:'green',
    trailColor:'blue',
    value:0,
    btype:'',
    text:'',
    status:''
  };

  const wfBn = wfBanner.split(",");
  const hour = parseInt(wfBn[0]);
  const rewarning = parseInt(wfBn[1]);
  result.btype = wfBn[2];
  result.status = wfBn[3];
  const tstatus = wfBn[4];

  result.text = text;

  var fontNo = 0;
  var day = Math.floor(hour / 24);
  var bgColor = "white";
  var pathColor = "green";
  var trailColor = "red";
  var type = 1;

  if (result.status==='Completed') {
      if (rewarning>0 && day > rewarning) { // overdue
          fontNo = 4;
      } else {
          fontNo = 3;
      }
      bgColor = PG_CIRCLE[fontNo].color;
      pathColor = PG_CIRCLE[fontNo].pathColor;
      trailColor = PG_CIRCLE[fontNo].trailColor;
  }
  else {

    if (result.btype==="t" && tstatus==="Completed") {
      if (rewarning>0 && day > rewarning) { // overdue
          fontNo = 4;
      } else {
          fontNo = 3;
      }
      bgColor = PG_CIRCLE[fontNo].color;
      pathColor = PG_CIRCLE[fontNo].pathColor;
      trailColor = PG_CIRCLE[fontNo].trailColor;
    }
    else
    if (rewarning===0) {
      fontNo = 1;
      bgColor = PG_CIRCLE[fontNo].color;
      pathColor = PG_CIRCLE[fontNo].pathColor;
      trailColor = PG_CIRCLE[fontNo].trailColor;
    } else
    if (hour > rewarning*24) { // overdue
      fontNo = 2;
      bgColor = PG_CIRCLE[fontNo].color;
      pathColor = PG_CIRCLE[fontNo].pathColor;
      trailColor = PG_CIRCLE[fontNo].trailColor;
    } else {
      var w = (hour>=0 ? hour :0) * 100 / (rewarning * 24);

      result.value = w;

      bgColor = PG_CIRCLE[0].color;
      pathColor = PG_CIRCLE[0].pathColor;
      trailColor = PG_CIRCLE[0].trailColor;

      type = 2;
    } 
  }

  result.color = PG_TEXT[fontNo].color;
  result.bgColor = bgColor;
  result.pathColor = pathColor;
  result.trailColor = trailColor;
  result.type = type;

  return result;
}

const StatusCircle: React.FC<StatusCircleProps> = ({ textSize, ccParam}) => {

  var res = ccParam;
//  getCircleParam(wfBanner, text, pgCircle, pgText, width);

  if (res.status!=='Completed' || res.btype==="wf") {
    return (
      <div style={{width:"50px"}}>
      <CircularProgressbar value={res.value} text={`${res.text}`} 
      background
      styles={buildStyles({
        textSize:textSize,
        textColor:res.color,
        pathColor:res.pathColor,
        trailColor:res.trailColor,
        backgroundColor:res.bgColor
      })}/>
      </div>
    );
  } else {
    return <></>
  }
};

export default StatusCircle;
